<template>
  <div style="display: flex; justify-content: center; align-items: center; height: 100vh; background-color: #f5f7fa;">
    <el-button @click="downloadPDA()" type="primary" size="large">PDA下载</el-button>
  </div>
</template>
<script>
export default {
  name: 'downPda',
  methods: {
    downloadPDA() {
      window.open('https://www.buyunxt.com/pda/pda.apk', '_blank');
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/downloadPda/index.vue